import gsap from 'gsap';

function closeAllAccordions(accordions, clickedAccordion) {
    accordions.forEach((accordion) => {
        if ( accordion === clickedAccordion ) return; // skip the clicked accordion

        const content = accordion.querySelector('[data-target="accordion-content"]');
        accordion.dataset.state = 'closed';
        gsap.to(content, { height: 0, duration: 0.5 });
		gsap.to(accordion.querySelector('.icon .plus-vertical'), { rotate: '0deg', transformOrigin: 'center', duration: 0.5 });
    });
}


function accordion() {
    const accordions =  document.querySelectorAll('[data-target="accordion"]');

    if ( ! accordions ) return;

    accordions.forEach((accordion) => {
        const trigger = accordion.querySelector('[data-target="accordion-trigger"]');
        const content = accordion.querySelector('[data-target="accordion-content"]');

        trigger.addEventListener('click', (event) => {
            const { state } = accordion.dataset;

            closeAllAccordions(accordions, event.currentTarget.parentNode);

			if ( state === 'closed' ) {
				accordion.dataset.state = 'open';
				gsap.to(content, { height: 'auto', duration: 0.5 });
				gsap.to(accordion.querySelector('.icon .plus-vertical'), { rotate: '-90deg', transformOrigin: 'center', duration: 0.5 });
			} else {
				accordion.dataset.state = 'closed';
				gsap.to(content, { height: 0, duration: 0.5 });
				gsap.to(accordion.querySelector('.icon .plus-vertical'), { rotate: '0deg', transformOrigin: 'center', duration: 0.5 });
			}
        });
    });


    if ($(".page-template-team").length) {
    
      $('[data-name="team-menu-link" ]').on( "click", function(e){
        e.preventDefault();
        
        var tab_id = $(this).data('id');
        console.log(tab_id);
        var section = '#' + tab_id;
  
        if ( tab_id === 'all' ) {
          gsap.to('[data-name="team-section"]', { height: 'auto', opacity: 1, duration: 0.5 });
        } else {
          gsap.to('[data-name="team-section"]', { height: 0, opacity:0, duration: 0.5 });
          gsap.to(section, { height: 'auto', opacity: 1, duration: 0.5 });
        }
        closeAllAccordions(accordions, e.currentTarget.parentNode);
  
      });
  
  
    } 
}

export default accordion;